module.exports = __webpack_public_path__ + "static/headerbg_right-716df22716fdd5b6220363946bd27041.gif";